
export const sizesOptions = {
  lg: {
    fontSize: 'sm',
    h: '10xl',
    minW: '10xl',
    borderRadius: '0.571429em',
    px: '0.857143em',
  },
  md: {
    fontSize: 'sm',
    h: '5xl',
    minW: '5xl',
    borderRadius: '0.571429em',
    px: '0.857143em',
  },
  sm: {
    fontSize: 'xs',
    h: '2xl',
    minW: '2xl',
    borderRadius: '0.333333em',
    px: '0.666667em',
  },
  xs: {
    fontSize: 'xs',
    h: 'md',
    minW: 'md',
    borderRadius: '0.333333em',
    px: '0.333333em',
  }
}